<template>
  <v-dialog
    v-model="recursoHabilitacaoDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="recursoHabilitacaoDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          Recurso da Habilitação - Organização ou Entidade Cultural
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>

      <v-card-text>
        <v-form
          ref="form_recurso_habilitacao_org"
          v-model="isValid"
        >
          <v-container>
            <v-card>
              <v-card-text v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR">
                <v-layout
                  align-space-between
                  justify-space-between
                  row
                >
                  <v-flex
                    v-if="!formulario.avaliador"
                    sm11
                  >
                    <v-btn
                      v-if="formulario.dh_habilitacao == null"
                      round
                      color="secondary"
                      @click="abrirDialogoSelecaoAvaliador"
                    >
                      <v-icon left>
                        add
                      </v-icon>
                      Incluir Avaliador
                    </v-btn>
                  </v-flex>

                  <v-flex
                    v-else
                    sm11
                  >
                    <v-layout>
                      <v-text-field
                        v-model="formulario.avaliador.no_nome"
                        style="max-width: 320px; margin-right: 50px;"
                        label="Nome do Avaliador"
                        append-icon="perm_identity"
                        disabled
                      />
                      <v-text-field
                        v-model="formulario.avaliador.nu_cpf"
                        style="max-width: 240px;"
                        label="CPF do Avaliador"
                        append-icon="person"
                        mask="###.###.###-##"
                        disabled
                      />
                    </v-layout>
                    <v-btn
                      v-if="formulario.dh_habilitacao == null"
                      round
                      color="secondary"
                      @click="abrirDialogoSelecaoAvaliador"
                    >
                      <v-icon
                        small
                        left
                      >
                        edit
                      </v-icon>
                      Alterar Avaliador
                    </v-btn>
                  </v-flex>
                  <v-flex
                    sm3
                  >
                    <v-btn
                      max-width="20px"
                      round
                      color="gray"
                      small
                      @click="abrirDialogoHistorico"
                    >
                      <v-icon
                        left
                        small
                      >
                        history
                      </v-icon>
                      Histórico
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card>
              <v-card-text>
                <v-layout
                  align-content-space-between
                  justify-space-between
                  wrap
                >
                  <v-flex sm6>
                    <v-text-field
                      :value="formulario.habilitacaoOrganizacao.organizacao.no_organizacao"
                      label="Nome da organização/entidade cultural"
                      append-icon="people_outline"
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    sm6
                    pl-3
                  >
                    <v-btn
                      round
                      color="secondary"
                      small
                      @click="abrirDialogoEntidade"
                    >
                      <v-icon left>
                        subject
                      </v-icon>
                      Ver Detalhes da Inscricao
                    </v-btn>
                  </v-flex>
                  <v-flex sm6>
                    <v-text-field
                      :value="formulario.habilitacaoOrganizacao.organizacao.segmento.ds_detalhamento"
                      label="Segmento cultural"
                      append-icon="people_outline"
                      disabled
                    />
                  </v-flex>
                  <v-flex
                    sm6
                    pl-3
                  >
                    <v-text-field
                      :value="formulario.habilitacaoOrganizacao.organizacao.nu_cnpj"
                      label="CNPJ"
                      append-icon="people_outline"
                      mask="##.###.###/####-##"
                      disabled
                    />
                  </v-flex>
                  <v-flex sm6>
                    <v-text-field
                      :value="formulario.habilitacaoOrganizacao.organizacao.pontuacao"
                      label="Pontuação inicial"
                      append-icon="people_outline"
                      disabled
                    />
                  </v-flex>
                  <v-flex sm6 pl-3>
                    <v-text-field
                      :value="formulario.habilitacaoOrganizacao.pontuacao_habilitacao"
                      label="Pontuação Após Habilitação"
                      append-icon="people_outline"
                      disabled
                    />
                  </v-flex>
                </v-layout>
                <v-card>
                  <v-card-title class="error--text">
                    <h3><b>Favor Verificar Dados do Recurso enviados através de email para o endereço <span class="indigo--text">votacultura@turismo.gov.br</span>!</b></h3>
                  </v-card-title>
                </v-card>
            <v-card mt-4>
                  <v-card-title primary-title>
                    <h3><b>Critérios</b></h3>
                  </v-card-title>
                  <v-layout
                    column
                    wrap
                    justify-center
                  >
                    <v-flex
                      v-for="criterio in criteriosAvaliacao"
                      :key="criterio.co_criterio"
                    >
                    <v-card
                        v-if="criterio.co_criterio"
                        elevation-1
                      >
                        <v-layout>
                          <v-flex
                            sm10
                            ma-3
                          >
                            <v-text-field
                                :value="criterio.ds_detalhamento"
                                style="margin-right: 50px;"
                                :label="criterio.ds_criterio"
                                disabled
                            />
                          </v-flex>
                          <v-flex
                            sm1
                            md-3
                            mt-1
                          >
                          <v-text-field
                            v-model="criterio.nu_nova_pontuacao"
                            label="Pontuação"
                            :disabled="recursoAvaliado()"
                          />
                          </v-flex>
                        </v-layout>
                        </v-card>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    class="mt-3"
                    wrap
                    align-center
                  >
                    <v-flex
                      xs12
                      sm12
                      lg12
                    >
                      <v-card>
                        <v-card-title color="white darken-3">
                          <h3><b>Avaliação</b></h3>
                        </v-card-title>

                        <v-layout>
                          <v-flex
                            xs6
                            sm6
                            md6
                            lg6
                            class="px-3"
                          >
                          <v-radio-group
                            v-model="formulario.st_parecer"
                            :rules="[rules.required]"
                          >
                            <v-radio
                              value="1"
                              color="success"
                            >
                              <template v-slot:label>
                                <div><strong class="success--text">Recurso Deferido</strong></div>
                              </template>
                            </v-radio>
                            <v-radio
                              value="0"
                              color="error"
                            >
                              <template v-slot:label>
                                <div><strong class="error--text">Recurso Indeferido</strong></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                          </v-flex>
                          <v-flex
                            xs6
                            sm6
                            md6
                            lg6
                            class="pa-3"
                          >
                            <v-select
                              v-model="formulario.st_nova_habilitacao"
                              :items="organizacaoUtils.opcoesStatusHabilitacao"
                              label="*Novo Resultado da Habilitação"
                              item-value="st_habilitacao"
                              item-text="ds_habilitacao"
                              :rules="[rules.required, rules.habilitada]"
                              required
                              :disabled="recursoAvaliado()"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex class="pa-3">
                            <v-textarea
                              v-model="formulario.ds_parecer"
                              box
                              label="* Parecer"
                              name="input-7-4"
                              rows="13"
                              row-height="28"
                              :counter="3000"
                              :rules="[rules.required, rules.tamanhoMaximo3000Caracteres]"
                              :disabled="recursoAvaliado()"
                            />
                          </v-flex>
                        </v-layout>
                        <v-flex
                          xs6
                          sm6
                          md6
                          lg6
                          class="pa-3"
                        >
                    <v-text-field
                      :value="criteriosAvaliacao | somaPontuacao"
                      label="Pontuação após análise"
                      disabled
                    />
                  </v-flex>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  @click="recursoHabilitacaoDialog= false"
                >
                  <v-icon left>
                    undo
                  </v-icon>
                  Voltar
                </v-btn>
                <v-btn
                  :loading="isLoading"
                  :disabled="!isValid || isLoading || recursoAvaliado()"
                  color="primary"
                  @click.native="abrirDialogo"
                >
                  <v-icon left>
                    send
                  </v-icon>
                  Avaliar
                </v-btn>
                <v-btn
                  v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR
                    && recursoAvaliado()"
                  :loading="isLoading"
                  color="primary"
                  @click.native="abrirDialogoEditar"
                >
                  <v-icon left>
                    edit
                  </v-icon>
                  Editar parecer
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="modalConfirmacao"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirm-text="Sim"
        :is-loading="isLoading"
        @dialog-response="respostaDialog"
      />
    </v-layout>

    <v-layout justify-center>
      <selecao-avaliador-dialog
        v-model="modalSelecaoAvaliador"
        :props-avaliador="selecaoAvaliador"
        :is-loading="isLoadingSelecao"
        @alterar="alterarAvaliador"
      />
    </v-layout>

    <v-layout justify-center>
      <organizacao-detalhes-inscricao-visualizacao-dialog
        v-model="modalDialogoEntidade"
        :is-loading="isLoadingEntidade"
      />
    </v-layout>

    <v-layout justify-center>
      <historico-recurso-habilitacao-dialog
        v-model="modalDialogoHistorico"
        :codigo-recurso="formulario.co_recurso_habilitacao_organizacao"
        :tipo-recurso="recursoUtils.RECURSO_HABILITACAO_ORGANIZACAO"
      />
    </v-layout>

    <v-layout justify-center>
      <v-dialog
        v-model="modalDialogoEditar"
        max-width="800"
      >
        <v-card>
          <v-layout
            wrap
            align-center
          >
                <v-card-title primary-title>
                    <h3><b>Critérios</b></h3>
                  </v-card-title>
                  <v-layout
                    column
                    wrap
                    justify-center
                  >
                    <v-flex
                      v-for="criterio in criteriosEdicao"
                      :key="criterio.co_criterio"
                    >
                    <v-card
                        v-if="criterio.co_criterio"
                        elevation-1
                      >
                        <v-layout>
                          <v-flex
                            sm10
                            ma-3
                          >
                            <h4>
                              <b>{{ criterio.ds_criterio }}</b>
                            </h4>
                          </v-flex>
                          <v-flex
                            sm1
                            md-3
                            mt-1
                          >
                          <v-text-field
                            v-model="criterio.nu_nova_pontuacao"
                            label="Pontuação"
                            :rules="[rules.required]"
                          />
                          </v-flex>
                        </v-layout>
                        </v-card>
                    </v-flex>
                  </v-layout>

            <v-flex
              xs12
              sm12
              class="ma-3"
            >
              <div class="ma-4 text-justify subheading grey--text">
                <b>Parecer:</b>
              </div>
              <v-textarea
                v-model="formularioEditado.ds_parecer"
                name="input-7-1"
                box
                solo
                label="Parecer da Habilitação"
                auto-grow
                :placeholder="'Digite seu parecer aqui.'"
                :counter="3000"
                :rules="[rules.required, rules.tamanhoMaximo3000Caracteres]"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
          >
            <v-flex
              xs12
              sm12
              class="ma-3"
            >
              <div class="ma-4 text-justify subheading grey--text">
                <b>Justificativa da edição:</b>
              </div>
              <v-textarea
                v-model="formularioEditado.ds_edicao_justificativa"
                name="input-7-1"
                box
                solo
                label="Justificativa da edição da Habilitação"
                auto-grow
                :placeholder="'Digite sua justificativa de edição da habilitação aqui.'"
                :counter="3000"
                :rules="[rules.required, rules.tamanhoMaximo3000Caracteres]"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
          >
          <v-flex
                            xs6
                            sm6
                            md6
                            lg6
                            class="px-3"
                          >
                          <v-radio-group
                            v-model="formularioEditado.st_parecer"
                            :rules="[rules.required]"
                          >
                            <v-radio
                              value="1"
                              color="success"
                            >
                              <template v-slot:label>
                                <div><strong class="success--text">Recurso Deferido</strong></div>
                              </template>
                            </v-radio>
                            <v-radio
                              value="0"
                              color="error"
                            >
                              <template v-slot:label>
                                <div><strong class="error--text">Recurso Indeferido</strong></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                          </v-flex>
            <v-flex
            xs6
            sm6
            md6
            lg6
            class="pa-3"
            >
            <v-select
                v-model="formularioEditado.st_nova_habilitacao"
                :items="organizacaoUtils.opcoesStatusHabilitacao"
                label="*Resultado da Habilitação"
                item-value="st_habilitacao"
                item-text="ds_habilitacao"
                :rules="[rules.required, rules.habilitada]"
                required
            />
            </v-flex>
        </v-layout>
          <v-card-actions v-if="!isLoadingSelecao">
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              flat
              @click="fecharDialogoEditar"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              flat
              :disabled="!formularioEditado.ds_edicao_justificativa || formularioEditado.st_nova_habilitacao == null"
              @click="editar"
            >
              Editar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import codigosPerfil from '../../conta/utils/codigosPerfil';
import organizacaoUtils from '../../organizacao/utils/organizacaoUtils';
import recursoUtils from '../utils/recursoUtils';
import { eventHub } from '@/event';

import DialogConfirmacao from '../../shared/components/DialogConfirmacao';
import File from '@/core/components/upload/File';
import SelecaoAvaliadorDialog from '../../recurso/views/components/SelecaoAvaliadorDialog';
import HistoricoRecursoHabilitacaoDialog from './components/HistoricoRecursoHabilitacaoDialog.vue';
import OrganizacaoDetalhesInscricaoVisualizacaoDialog from '../../organizacao/views/components/OrganizacaoDetalhesInscricaoVisualizacaoDialog';

export default {
  name: 'ListaHabilitacaoOrganizacaoRecursoDialog',
  components: {
    DialogConfirmacao,
    File,
    SelecaoAvaliadorDialog,
    HistoricoRecursoHabilitacaoDialog,
    OrganizacaoDetalhesInscricaoVisualizacaoDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    recursoHabilitacaoOrganizacao: {
      type: Object,
      default:() => {},
    },
  },
  data() {
    return {
      codigosPerfil,
      organizacaoUtils,
      recursoUtils,
      modalConfirmacao: false,
      modalSelecaoAvaliador: false,
      modalDialogoEntidade: false,
      modalDialogoHistorico: false,
      modalDialogoEditar: false,
      recursoHabilitacaoDialog: false,
      isLoading: false,
      isLoadingRequest: false,
      isLoadingHistorico: false,
      isLoadingSelecao: false,
      isLoadingEntidade: false,
      isValid: false,
      fileLoaded: false,
      selecaoAvaliador: {
        co_usuario: 0,
        co_objeto: 0,
      },
      criteriosAvaliacao: [],
      criteriosEdicao: [],
      formularioEditado: {},
      formulario: {
        habilitacaoOrganizacao: {
          organizacao: {
            no_organizacao: '',
            nu_cnpj_formatado: '',
            pontuacao: '',
            segmento: {
              ds_detalhamento: '',
            }
          }
        },
        st_nova_habilitacao: '-1'
      },
      formularioInicial: {
        habilitacaoOrganizacao: {
          organizacao: {
            no_organizacao: '',
            nu_cnpj_formatado: '',
            pontuacao: '',
            segmento: {
              ds_detalhamento: '',
            }
          }
        },
        st_nova_habilitacao: '-1'
      },
      rules: {
        required: value => !!value || 'Este campo é obrigatório',
        habilitada: value => value != '-1' || 'Este campo é obrigatório',
        minCaracter: value => value.length >= 8 || 'Mínimo 8 caracteres',
        tamanhoMaximo500Caracteres: value => (!!value && value.length <= 500) || 'Máximo 500 caracteres',
        tamanhoMaximo3000Caracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
      },
    };
  },
  filters: {
    somaPontuacao(criterios) {
      if(criterios){
        return criterios.reduce((accumulator, value) => {
          return accumulator + (parseInt(value.nu_nova_pontuacao)? parseInt(value.nu_nova_pontuacao):0);
        }, 0);
      }else{
        return 0;
      }
    },
  },
  computed: {
    ...mapGetters({
      perfil: 'conta/perfil',
      avaliadores: 'conta/usuarios',
    }),
  },
  watch: {
    value(alternarDialogRecurso) {
      this.recursoHabilitacaoDialog = alternarDialogRecurso;
      if (!alternarDialogRecurso) {
        this.isLoadingEntidade = false;
        this.formulario = Object.assign({}, this.formularioInicial);
        this.criteriosAvaliacao = [];
        this.$refs.form_recurso_habilitacao_org.reset();
      }
    },
    recursoHabilitacaoDialog(alternarDialogRecurso) {
      this.$emit('input', alternarDialogRecurso);
      this.formulario = Object.assign({});
      this.criteriosAvaliacao = [];
      this.$refs.form_recurso_habilitacao_org.reset();
      if (Object.keys(this.recursoHabilitacaoOrganizacao).length) {
        this.formulario = Object.assign({}, this.recursoHabilitacaoOrganizacao);

        this.selecaoAvaliador = {
          co_usuario: this.recursoHabilitacaoOrganizacao.avaliador ? this.recursoHabilitacaoOrganizacao.avaliador.co_usuario : 0,
          co_objeto: this.recursoHabilitacaoOrganizacao.co_recurso_habilitacao_organizacao,
        };

        this.confirmarOrganizacao(this.recursoHabilitacaoOrganizacao.habilitacaoOrganizacao.organizacao);

        this.formulario.st_nova_habilitacao = this.recursoHabilitacaoOrganizacao.habilitacaoOrganizacao.st_habilitacao;
        
        this.recursoHabilitacaoOrganizacao.habilitacaoOrganizacao.criteriosHabilitacao.forEach((item) => {
          this.criteriosAvaliacao.push({
            co_recurso_habilitacao_organizacao_criterio: item.co_recurso_habilitacao_organizacao_criterio,
            co_recurso_habilitacao_organizacao: this.recursoHabilitacaoOrganizacao.co_recurso_habilitacao_organizacao,
            co_criterio: item.co_criterio,
            tp_criterio: item.tp_criterio,
            ds_criterio: item.ds_criterio,
            ds_detalhamento: item.ds_detalhamento,
            nu_nova_pontuacao: this.recursoHabilitacaoOrganizacao.st_parecer == -1 ? item.nu_nova_pontuacao : item.nu_pontuacao_recurso,
          });
        });

      }
    },
    recursoHabilitacaoOrganizacao(recurso) {
      this.formulario = Object.assign({}, recurso);
      this.formulario.st_nova_habilitacao = recurso.habilitacaoOrganizacao.st_habilitacao;
    },
  },
  methods: {
    ...mapActions({
      downloadArquivo: 'shared/downloadArquivo',
      atualizarAvaliador: 'recurso/atualizarAvaliadorHabilitacaoOrganizacao',
      obterHistoricoRecurso: 'recurso/obterHistoricoRecursoHabilitacaoOrganizacao',
      avaliarRecurso: 'recurso/avaliarRecursoHabilitacaoOrganizacao',
      confirmarOrganizacao: 'organizacao/confirmarOrganizacao',
    }),
    respostaDialog(tipoResposta) {
      if (tipoResposta) {
        this.salvar();
      } else {
        this.fecharDialogo();
      }
    },
    salvar() {
      if (!this.$refs.form_recurso_habilitacao_org.validate()) {
        return false;
      }

      this.isLoading = true;

      const recursoHabilitacaoOrganizacaoToSave = {
        co_recurso_habilitacao_organizacao: this.formulario.co_recurso_habilitacao_organizacao,
        st_parecer: this.formulario.st_parecer,
        ds_parecer: this.formulario.ds_parecer,
        ds_edicao_justificativa: this.formulario.ds_edicao_justificativa,
        criterios: this.criteriosAvaliacao,
        st_nova_habilitacao: this.formulario.st_nova_habilitacao,
      };

      this.avaliarRecurso(recursoHabilitacaoOrganizacaoToSave)
        .then(() => {
          this.recursoHabilitacaoDialog = false;
          this.$emit('salvo');
        })
        .finally((response) => {
          this.isLoading = false;
          this.modalConfirmacao = false;
          this.modalDialogoEditar = false;
          this.isLoadingHistorico = true;
          this.obterHistoricoRecurso(recursoHabilitacaoOrganizacaoToSave.co_recurso_habilitacao_organizacao);
        });
      return true;
    },
    editar() {
      this.formularioEditado.ds_edicao_justificativa = this.formularioEditado.ds_edicao_justificativa.trim();
      if (!this.formularioEditado.ds_edicao_justificativa) {
        return;
      }
      Object.assign(this.formulario, this.formularioEditado);
      this.criteriosAvaliacao = Object.assign([], this.criteriosEdicao);
      this.abrirDialogo();
    },
    abrirDialogo() {
      if (!this.$refs.form_recurso_habilitacao_org.validate()) {
        return false;
      }
      this.modalConfirmacao = true;
      return true;
    },
    abrirDialogoSelecaoAvaliador() {
      this.modalSelecaoAvaliador = true;
      return true;
    },
    abrirDialogoEntidade() {
      this.modalDialogoEntidade = true;
      return true;
    },
    abrirDialogoHistorico() {
      this.modalDialogoHistorico = true;
      return true;
    },
    abrirDialogoEditar() {
      this.formularioEditado.ds_parecer = `${this.formulario.ds_parecer}`;
      this.formularioEditado.st_nova_habilitacao = `${this.formulario.st_nova_habilitacao}`;
      this.criteriosEdicao = Object.assign([], this.criteriosAvaliacao);
      this.modalDialogoEditar = true;
      return true;
    },
    fecharDialogo() {
      this.modalConfirmacao = false;
    },
    fecharDialogoSelecaoAvaliador() {
      this.modalSelecaoAvaliador = false;
    },
    fecharDialogoEntidade() {
      this.modalDialogoEntidade = false;
    },
    fecharDialogoEditar() {
      this.formularioEditado = {};
      this.criteriosEdicao = this.criteriosAvaliacao;
      this.modalDialogoEditar = false;
    },
    alterarAvaliador(avaliadorSelecionado) {
      if (this.formulario.avaliador
                && (this.formulario.avaliador.co_usuario == avaliadorSelecionado.co_usuario
                    || !avaliadorSelecionado.co_usuario
                    || avaliadorSelecionado.co_usuario == 0)) {
        this.fecharDialogoSelecaoAvaliador();
        return;
      }

      this.isLoadingSelecao = true;

      this.atualizarAvaliador(avaliadorSelecionado).finally(() => {
        this.formulario.avaliador = this.avaliadores.find(item => item.co_usuario === avaliadorSelecionado.co_usuario);
        this.isLoadingSelecao = false;
        this.isLoadingHistorico = true;
        this.obterHistoricoRecurso(this.formulario.co_recurso_habilitacao_organizacao);
        eventHub.$emit(
          'eventoSucesso',
          'Atualizado com sucesso! Um email será enviado para o avaliador.',
        );
        this.fecharDialogoSelecaoAvaliador();
      });
    },
    recursoAvaliado() {
      return this.formulario.dh_parecer !== null;
    },
  },
};
</script>
